import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, message, Card, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import EyeCursor from "../../components/other/eyeCursor";
import { useLoading } from "../../context/loadingContext";
import AdminAuth from "../../functions/admin/adminAuth";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import { useAdmin } from "context/adminContext";

const AdminLogin = () => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const { setAdminId } = useAdmin();
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("admin")) navigate("/adminDashoard");
    const username = localStorage.getItem("username");
    if (username) form.setFieldsValue({ username: username });
    else form.setFieldsValue({ username: "admin", password: "admin1234" });
  }, []);
  const onFinish = async (values) => {
    showLoading();
    //await waitFor(10)
    const result = await AdminAuth(values);
    console.log(result);
    hideLoading(false);
    if (result && result.token) {
      localStorage.setItem("merchantToken", result.token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${result.token}`;
      console.log(result.data);
      localStorage.setItem("adminId", result.data.id);
      setAdminId(result.data.id);
      if (values.remember)
        localStorage.setItem("adminUsername", values.username);
      localStorage.setItem("merchantData", JSON.stringify(result.data));
      navigate("/adminDashboard");
    } else message.error("Invalid credentials");
    // redirect to merchant dashboard
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const [rotation, setRotation] = useState(180); // Initial rotation angle

  const handleMouseMove = (event) => {
    const eye = document.querySelector(".eye");
    if (eye) {
      const eyeRect = eye.getBoundingClientRect();
      const eyeCenterX = eyeRect.left + eyeRect.width / 2;
      const eyeCenterY = eyeRect.top + eyeRect.height / 2;

      const angleRad = Math.atan2(
        event.clientX - eyeCenterX,
        event.clientY - eyeCenterY
      );
      const angleDeg = angleRad * (180 / Math.PI) * -1 + 180; // Convert rad to degrees and rotate
      setRotation(angleDeg); // Update the rotation state
    }
  };
  const [visible, setVisible] = useState(true);
  const toggleVisibility = (hide) => {
    setVisible(hide);
  };
  return (
    <div
      className="move-area"
      onMouseMove={handleMouseMove}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Card
        style={{
          minWidth: "400px",
          maxWidth: "600px",
          borderRadius: 20,
          alignSelf: "center",
          margin: "auto",
          padding: "30px",
        }}
        className={`${bg_shadow}`}
      >
        {/* <HeartPulse /> */}
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
          }}
        >
          <span
            className={`${bg_text} font-bold mb-2`}
            style={{ fontSize: 30 }}
          >
            Aдмин Нэвтрэх
          </span>
          <span
            className={`${bg_text} text-sm text-transparent font-extrabold mb-6 leading-tight`}
          >
            Rapid, Reliable, Rewarding
          </span>
        </div>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          form={form}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label="Нэвтрэх нэр"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Нууц үг"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              visibilityToggle={true}
              iconRender={(visible) => (
                <EyeCursor
                  onClick={toggleVisibility}
                  visible={visible}
                  rotation={rotation}
                />
              )}
            />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Намайг сана</Checkbox>
          </Form.Item>
          <Row style={{ width: "100%" }}>
            <Col
              span={24}
              style={{
                justifyItems: "center",
                textAlign: "center",
                width: "100%",
              }}
            >
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className={`${bg_button}`}
                >
                  Нэвтрэх
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default AdminLogin;
